import React from "react";
import s from "./InputDetectedFromWrongDevicePrompt.module.scss";
import {keyboardWizardStore} from "../../../../redux/keyboardWizard/keyboardWizardStore";
import {useAppSelector} from "../../../../redux/hooks";
import {GenericModal} from "../../../common/genericModal/GenericModal";
import Button from "../../../common/Button";

interface IInputDetectedFromWrongDevicePromptProps {
}

export default function InputDetectedFromWrongDevicePrompt({}: IInputDetectedFromWrongDevicePromptProps) {
  const canShow = useAppSelector(keyboardWizardStore.getCanShowInputDetectedFromWrongDeviceModal);
  const shouldShow = useAppSelector(keyboardWizardStore.getShowInputDetectedFromWrongDeviceModal);
  const deviceToConfigureName = useAppSelector(keyboardWizardStore.getDeviceToConfigureName);
  const activeDeviceId = useAppSelector(keyboardWizardStore.getActiveDeviceId);
  const activeDeviceName = useAppSelector(keyboardWizardStore.getActiveDeviceName);

  if (!canShow || !shouldShow) {
    return null;
  }

  return (
    <GenericModal
      canShow={(): boolean => true}
      backgroundColor={"white"}
      title={"Switch device?"}
      onClose={() => {
        keyboardWizardStore.setShowInputDetectedFromWrongDeviceModal(false);
        keyboardWizardStore.setCanShowInputDetectedFromWrongDeviceModal(false);
      }}
    >
      <div className={s.container}>
        <div className={s.topText}>
          <p>Expected input from <strong>{deviceToConfigureName}</strong>, but received input from <strong>{activeDeviceName}</strong>.</p>
          <p>Would you like to switch to <strong>{activeDeviceName}</strong>?</p>
        </div>

        <div className={s.buttonSection}>
          <Button
            text={`Switch`}
            onClick={() => {
              keyboardWizardStore.setDeviceToConfigureId(activeDeviceId);
              keyboardWizardStore.setDeviceToConfigureName(activeDeviceName);
              keyboardWizardStore.setShowInputDetectedFromWrongDeviceModal(false);
              keyboardWizardStore.setCanShowInputDetectedFromWrongDeviceModal(false);
            }}
            buttonType={`secondary`}
          >
          </Button>
          <Button
            text={`Do Not Switch`}
            onClick={() => {
              keyboardWizardStore.setShowInputDetectedFromWrongDeviceModal(false);
              keyboardWizardStore.setCanShowInputDetectedFromWrongDeviceModal(false);
            }}
            buttonType={`secondary`}
          >
          </Button>
        </div>
      </div>
    </GenericModal>
  );
}
